<template>
  <v-row dense justify="center" align="center" class="ma-0 pa-0">
    <v-container class="ma-0 pa-0">
      <v-progress-linear indeterminate :active="loading"></v-progress-linear>
      <iframe v-if="paymentUrl" :src="paymentUrl"
        :onload="loading = false" width="100%" height="1550px" frameborder="0" />
    </v-container>
  </v-row>
</template>

<script>

export default {
  data: () => ({
    loading: true,
    paymentUrl: null,
  }),
  sockets: {
    connect() {
      console.log('SOCKET - connected to chat server');
    },
    count(val) {
      console.log(`SOCKET - count val: ${val}`);
      // this.count = val.count;
    },
    message(data) { // this function gets triggered once a socket event of `message` is received
      console.log(`SOCKET - message data: ${data}`);
      // this.textarea += `${data}\n`;
      // append each new message to the textarea and add a line break
    },
  },
  computed: {
  },
  created() {
    const { query } = this.$route;
    if (query.q) {
      this.paymentUrl = JSON.parse(atob(query.q));
    }

    this.$socket.$subscribe('payment_confirmed', (payload) => {
      // console.log('payment_confirmed');
      // console.log(payload);
      const queryBase64 = btoa(JSON.stringify(payload));
      this.$router.push({ name: 'schedule-success', query: { q: queryBase64 } });
    });

    this.$socket.$subscribe('payment_canceled', (payload) => {
      // console.log('payment_canceled');
      // console.log(payload);
      this.$router.push({ name: 'payment-cancel' });
    });
  },
  methods: {
  },
  watch: {
  },
  components: {
  },
};
</script>
